import { render } from "./RadioGroup.vue?vue&type=template&id=427aab84&scoped=true&ts=true"
import script from "./RadioGroup.vue?vue&type=script&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&lang=ts"

import "./RadioGroup.vue?vue&type=style&index=0&id=427aab84&lang=scss&scoped=true"

import exportComponent from "../../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427aab84"]])

export default __exports__